(() => {
  'use strict';

  if (customElements.get('edvi-cart-timer')) return;

  const storageKey = 'edvi:cart-offer:ends-at:v1';
  const duration = (15 * 60 * 60 + 59 * 60 + 7) * 1000;
  const timers = new Set();
  let interval = null;

  function validDeadline(value, now) {
    return Number.isSafeInteger(value) && value > now && value <= now + duration;
  }

  function persistDeadline(value) {
    try {
      localStorage.setItem(storageKey, String(value));
    } catch {}
    return value;
  }

  function resolveDeadline(now) {
    try {
      const stored = Number(localStorage.getItem(storageKey));
      if (validDeadline(stored, now)) return stored;
    } catch {}
    return persistDeadline(now + duration);
  }

  let endsAt = resolveDeadline(Date.now());

  function remaining() {
    const now = Date.now();
    if (endsAt <= now) endsAt = resolveDeadline(now);
    return Math.ceil((endsAt - now) / 1000);
  }

  function refresh() {
    if (!timers.size) return;
    const seconds = remaining();
    timers.forEach(timer => timer.render(seconds));
  }

  class EdviCartTimer extends HTMLElement {
    connectedCallback() {
      if (timers.has(this)) return;
      this.hidden = true;
      queueMicrotask(() => {
        if (!this.isConnected || timers.has(this)) return;
        this.digits = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-timer-${unit}]`));
        if (this.digits.some(digit => !digit)) return;
        timers.add(this);
        this.render(remaining());
        this.hidden = false;
        if (interval === null) interval = window.setInterval(refresh, 1000);
      });
    }

    disconnectedCallback() {
      timers.delete(this);
      if (!timers.size && interval !== null) {
        window.clearInterval(interval);
        interval = null;
      }
    }

    render(seconds) {
      const values = [
        Math.floor(seconds / 86400),
        Math.floor(seconds / 3600) % 24,
        Math.floor(seconds / 60) % 60,
        seconds % 60
      ];
      this.digits.forEach((digit, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (digit.textContent !== value) digit.textContent = value;
      });
      this.dataset.endsAt = String(endsAt);
      this.dataset.remaining = String(seconds);
      this.dataset.ready = 'true';
    }
  }

  customElements.define('edvi-cart-timer', EdviCartTimer);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    const now = Date.now();
    const stored = Number(event.newValue);
    endsAt = validDeadline(stored, now) ? stored : resolveDeadline(now);
    refresh();
  });
})();
